import { useState, useEffect } from "react";
import localforage from "localforage";
import { signal, effect } from "@preact/signals-react"; 

export const useLocalContextStorage = (key, initialValue) => {
  localforage.config({
    name: 'reMind',
    isPersistent: true
});
 
  const [value, setValue] = useState();
  useEffect(()=>{
    const getData = async() => {
      localforage.getItem(key).then(item=>{
        if(item) {
          setValue(item)
        } else if(initialValue) {
          setValue(initialValue)
        }
    })}
    getData()
  },[key, initialValue])

  const setLocalValue = (value) => {
    try {
      //window.localStorage.setItem(key, JSON.stringify(value));
      localforage?.setItem(key, value)?.then(setValue(value))
      
    } catch (error) {
      alert("Something went wrong with setting localforage, see console");
      localforage.clear()
       console.log(error);   
    }
  }

  return [value, setLocalValue];
}

export const useHook = (key) => {
  localforage.config({
    name: 'reMind',
    isPersistent: true
  });

  const value = signal();

  // Load initial value from localforage
  effect(() => {
    localforage.getItem(key).then((item) => {
      if (item !== null && !value.value) {
        value.value = item;
      }
    });
  });

  // Automatically sync changes to localforage
  effect(() => {
    if (value.value !== undefined) {
      localforage.setItem(key, value.value);
    }
  });

  return [value];
};
